var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCuotaSimpleWithoutLegend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.543 7.56543L7.73508 12.4354C7.55319 12.6197 7.25457 12.6197 7.07268 12.4354L0.551764 5.83027C0.369873 5.64603 0.369873 5.34354 0.551764 5.1593L5.02844 0.624784C5.21033 0.440543 5.50896 0.440543 5.69085 0.624784L12.543 7.56543Z",
    fill: "#557EAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.39534 12.0664L9.58984 10.8564L2.11061 3.28058L0.916106 4.49052L8.39534 12.0664Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.7253 5.03597C4.65619 5.10597 4.66003 5.22263 4.73298 5.28875C5.22057 5.72041 5.83101 5.9343 6.43762 5.9343C7.10566 5.9343 7.76985 5.67764 8.27664 5.16041L9.2211 4.20375L12.5344 7.55986L13.5365 6.54486C14.9455 5.11763 15.0261 2.79597 13.6516 1.33375C12.9337 0.571523 11.97 0.186523 11.0102 0.186523C10.0773 0.186523 9.14432 0.54819 8.43405 1.26763L4.72146 5.02819L4.7253 5.03597Z",
    fill: "#242C4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuotaSimpleWithoutLegend);
export default __webpack_public_path__ + "static/media/cuotaSimpleWithoutLegend.2036ab945a07a91c5cde15ff26ddb48e.svg";
export { ForwardRef as ReactComponent };